export default __webpack_public_path__ + "static/media/Hands Holding Phone 1.65df7d4a.png";